import { Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { SendGeneralInquiry } from "../redux/actions/ContactActions";
import { useRef, useState } from "react";
import CircularProgress from '@mui/material/CircularProgress';

function GeneralInquiryForm(props){

    let dispatch = useDispatch()

    const [showError, setShowError] = useState(false);
    const [done, setDone] = useState(false);
    const [loading, setLoading] = useState(false);

    const firstNameRef = useRef();
    const lastNameRef = useRef();
    const emailRef = useRef();
    const pnumberRef = useRef();
    const msgRef = useRef();

    const handleCancel = () => {
        props.closeFunc();
    }

    const handleErrorCancel = () => {
        setShowError(false);
        setDone(false);
    }

    const handleSend = async () => {

        let blob = {
            FirstName: firstNameRef.current.value,
            LastName: lastNameRef.current.value,
            Email: emailRef.current.value,
            PhoneNumber: pnumberRef.current.value,
            Message: msgRef.current.value
        };

        setLoading(true);
        if(!await dispatch(await SendGeneralInquiry(blob))){
            setShowError(true);
        }else{
            setShowError(false);
        }

        setDone(true);
        setLoading(false);
    }

    const ErrorDialog = <Dialog open={showError} onClose={handleErrorCancel}>
                            <DialogTitle sx={{color: "red"}}>Unexpected Error</DialogTitle>
                            <DialogContent>
                                <Typography>We do apologize, an unexpected error has occured in transmitting your contact request, please contact us at: 123 456 7890</Typography>
                            </DialogContent>
                            <DialogActions>
                            <Button onClick={handleErrorCancel}>OK</Button>
                            </DialogActions>
                        </Dialog>

    const SuccessDialog = <Dialog open={!showError} onClose={handleErrorCancel}>
                                <DialogTitle>Sent!</DialogTitle>
                                <DialogContent>
                                    <Typography>Thank you for your inquiry - we will reach out to you shortly!</Typography>
                                </DialogContent>
                                <DialogActions>
                                <Button onClick={handleCancel}>OK</Button>
                                </DialogActions>
                            </Dialog>

    const ContactForm = <Dialog open={true} onClose={handleCancel}>
                            <DialogTitle>Contact C2 Custom Building!</DialogTitle>
                            <DialogContent>
                                <TextField
                                    inputRef={firstNameRef}
                                    sx={{ m: 1, minWidth: "90%", color: "black" }}
                                    id="outlined-search"
                                    label="First Name"
                                    type="search"
                                    />
                                    <TextField
                                    inputRef={lastNameRef}
                                    sx={{ m: 1, minWidth: "90%", color: "black" }}
                                    id="outlined-search"
                                    label="Last Name"
                                    type="search"
                                    />
                                    <TextField
                                    inputRef={emailRef}
                                    sx={{ m: 1, minWidth: "90%", color: "black" }}
                                    id="outlined-search"
                                    label="Email"
                                    type="search"
                                    />
                                    <TextField
                                    inputRef={pnumberRef}
                                    sx={{ m: 1, minWidth: "90%", color: "black" }}
                                    id="outlined-search"
                                    label="Phone Number"
                                    type="search"
                                    />
                                    <TextField
                                    inputRef={msgRef}
                                    multiline
                                    sx={{ m: 1, minWidth: "90%", color: "black" }}
                                    id="outlined-search"
                                    label="Message"
                                    type="search"
                                    />
                            </DialogContent>
                            <DialogActions>
                            <Button onClick={handleCancel}>Cancel</Button>
                            <Button onClick={handleSend}>Send</Button>
                            </DialogActions>
                        </Dialog>
    
    const ProgressDialogue = <Dialog open={true}>
                                <DialogContent>
                                    <CircularProgress variant={"indeterminate"} sx={{zIndex: 12000}}/> 
                                </DialogContent>
                             </Dialog>

    return(
        <div>
            {loading ? ProgressDialogue : <div />}
            {!loading ? ( done ? (showError ? ErrorDialog : SuccessDialog) : ContactForm ) : <div /> }
        </div>

    );

}

export default GeneralInquiryForm;